import { apiFetch } from "@/integrations/backend/client";

export type CheckoutSessionInput = {
  pricingTierId: string;
  billingCycle: "monthly" | "annual";
};

export type CheckoutSessionResponse = {
  checkout_url: string;
  session_id: string;
};

export async function createCheckoutSession(
  input: CheckoutSessionInput,
): Promise<CheckoutSessionResponse> {
  const res = await apiFetch("/api/v1/payments/checkout-session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      pricing_tier_id: input.pricingTierId,
      billing_cycle: input.billingCycle,
    }),
  });

  if (!res.ok) {
    throw new Error(`checkout_session_failed:${res.status}`);
  }

  return (await res.json()) as CheckoutSessionResponse;
}

export type CustomerPortalResponse = {
  portal_url: string;
};

export async function createCustomerPortalSession(): Promise<CustomerPortalResponse> {
  const res = await apiFetch("/api/v1/payments/customer-portal", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });

  if (!res.ok) {
    throw new Error(`customer_portal_failed:${res.status}`);
  }

  return (await res.json()) as CustomerPortalResponse;
}

